import { A4_HEIGHT_PX } from '@/document-render/domain/constants/pageMetrics';

/**
 * Shared cover-page layout sizes in CSS pixels (HTML preview source of truth).
 * PDF convert with `pxToPt` (0.75) so typography and logo proportions stay aligned.
 *
 * `minHeight` approximates a full A4 content area (default 48px page padding × 2)
 * so short covers still occupy the entire first sheet in preview and PDF.
 */
export const COVER_PAGE_LAYOUT_PX = {
  titleMinFontSize: 28,
  customerFontSize: 16,
  dateFontSize: 14,
  gap: 16,
  /** Full first-page body height at default padding — cover_page is atomic + pageBreakAfter. */
  minHeight: A4_HEIGHT_PX - 96
} as const;

export type CoverPageLayoutPx = typeof COVER_PAGE_LAYOUT_PX;

/** Convert cover-page px sizes to PDF points via the shared px→pt factor. */
export function coverPageLayoutPt(pxToPt: (px: number) => number): {
  titleMinFontSize: number;
  customerFontSize: number;
  dateFontSize: number;
  gap: number;
  minHeight: number;
} {
  return {
    titleMinFontSize: pxToPt(COVER_PAGE_LAYOUT_PX.titleMinFontSize),
    customerFontSize: pxToPt(COVER_PAGE_LAYOUT_PX.customerFontSize),
    dateFontSize: pxToPt(COVER_PAGE_LAYOUT_PX.dateFontSize),
    gap: pxToPt(COVER_PAGE_LAYOUT_PX.gap),
    minHeight: pxToPt(COVER_PAGE_LAYOUT_PX.minHeight)
  };
}
